var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoCollaborators(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H18C20.2091 0 22 1.79086 22 4V18C22 20.2091 20.2091 22 18 22H4C1.79086 22 0 20.2091 0 18V4Z",
    fill: "#EBFFEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4583 8.66667C12.4583 7.05584 11.1525 5.75 9.54167 5.75C7.93084 5.75 6.625 7.05584 6.625 8.66667C6.625 10.2775 7.93084 11.5833 9.54167 11.5833C11.1525 11.5833 12.4583 10.2775 12.4583 8.66667Z",
    stroke: "#5BAF5E",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0417 16.25L14.7917 14.5M14.7917 14.5L16.5417 12.75M14.7917 14.5L13.0417 12.75M14.7917 14.5L16.5417 16.25",
    stroke: "#5BAF5E",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.45825 15.6667C5.45825 13.4115 7.28642 11.5833 9.54159 11.5833C10.2853 11.5833 10.9827 11.7822 11.5833 12.1296",
    stroke: "#5BAF5E",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCollaborators);
export default __webpack_public_path__ + "static/media/No_collaborators.910c326abd9a2dbcc00255b7f4fff977.svg";
export { ForwardRef as ReactComponent };